import store from "@/store";

import { loadAuth } from "@/utils/auth";

export async function init() {
  loadAuth();
  await store.dispatch("settings/fetchServer");
  await loadSettings();
}

export async function loadSettings() {
  if (store.state.auth.success) {
    await store.dispatch("settings/getUserSetting", {
      path: "profile",
      key: "notifications",
    });

    await store.dispatch("settings/getUserSetting", {
      path: "profile",
      key: "infobar",
    });

    await store.dispatch("settings/getLicenseStats");
  }
}
